(function () {
  'use strict';

  // ── Countdown Timer ────────────────────────────────────────────
  function initCountdown() {
    var el = document.querySelector('[data-countdown-end]');
    if (!el) return;

    var endTime = new Date(el.dataset.countdownEnd).getTime();
    if (isNaN(endTime)) return;

    var hEl = el.querySelector('[data-countdown-hours]');
    var mEl = el.querySelector('[data-countdown-minutes]');
    var sEl = el.querySelector('[data-countdown-seconds]');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        var bar = el.closest('.cart-announcement');
        if (bar) bar.remove();
        clearInterval(timerId);
        return;
      }
      var total = Math.floor(diff / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    tick();
    var timerId = setInterval(tick, 1000);
  }

  // ── Progress Bar Animation ─────────────────────────────────────
  // Bars are Liquid-rendered with final widths. Reset to 0 then
  // animate to target so the CSS transition fires visibly.
  function animateFills() {
    document.querySelectorAll('[data-fill]').forEach(function (fill) {
      var target = fill.style.width;
      fill.style.transition = 'none';
      fill.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fill.style.transition = '';
          fill.style.width = target;
        });
      });
    });
  }

  // ── Free Gift Claim ────────────────────────────────────────────
  function initFreeGift() {
    document.querySelectorAll('[data-gift-claim]').forEach(function (btn) {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function () {
        var giftEl = btn.closest('[data-gift-variant]');
        var variantId = giftEl && giftEl.dataset.giftVariant;
        if (!variantId) return;
        btn.disabled = true;
        btn.textContent = '...';
        addToCart(variantId, 1)
          .then(function () { btn.textContent = 'Added!'; })
          .catch(function () { btn.disabled = false; btn.textContent = 'Claim free gift'; });
      });
    });
  }

  // ── Smart Cart Rules ───────────────────────────────────────────
  // Supports: data-cart-rule="total_above:5000"  (cents)
  //           data-cart-rule="total_below:5000"
  //           data-cart-rule="count_above:2"
  //           data-cart-rule="count_below:2"
  function evaluateCartRules() {
    var total = getCartTotalCents();
    var count = getCartCount();

    document.querySelectorAll('[data-cart-rule]').forEach(function (el) {
      var rule = el.dataset.cartRule || '';
      var parts = rule.split(':');
      var type = parts[0];
      var val = parseInt(parts[1], 10);
      var show = true;

      if (!isNaN(val)) {
        if (type === 'total_above') show = total > val;
        else if (type === 'total_below') show = total < val;
        else if (type === 'count_above') show = count > val;
        else if (type === 'count_below') show = count < val;
      }

      el.classList.toggle('cart-rule--visible', show);
    });
  }

  // ── Sticky Cart Button ─────────────────────────────────────────
  function initStickyCartButton() {
    // Only on product pages and only if drawer mode
    var drawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (!drawerTrigger) return;

    // Don't add if theme already has a sticky ATC bar
    if (document.querySelector('.sticky-add-to-cart')) return;

    var atcForm = document.querySelector('form[action="/cart/add"]');
    var atcBtn = atcForm && atcForm.querySelector('[type="submit"]');
    if (!atcBtn) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sticky-cart-btn';
    btn.setAttribute('aria-label', 'Open cart');
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>'
      + '<line x1="3" y1="6" x2="21" y2="6"/>'
      + '<path d="M16 10a4 4 0 0 1-8 0"/>'
      + '</svg>'
      + '<span class="sticky-cart-btn__badge" aria-hidden="true" data-sticky-count></span>';

    document.body.appendChild(btn);
    updateStickyBadge();

    btn.addEventListener('click', function () { drawerTrigger.click(); });

    var observer = new IntersectionObserver(function (entries) {
      btn.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });

    observer.observe(atcBtn);
  }

  function updateStickyBadge() {
    var badge = document.querySelector('[data-sticky-count]');
    if (!badge) return;
    var count = getCartCount();
    badge.textContent = count > 0 ? count : '';
  }

  // ── Cart AJAX ──────────────────────────────────────────────────
  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Failed'); });
        return r.json();
      })
      .then(function (data) {
        // Trigger theme's cart update flow
        document.dispatchEvent(new CustomEvent('CartAddEvent', {
          bubbles: true,
          detail: { items: data.items }
        }));
        return data;
      });
  }

  function getCartTotalCents() {
    var el = document.querySelector('.cart-progress-bar[data-total], .cart-free-gift[data-total]');
    if (el) return parseInt(el.dataset.total, 10) || 0;
    return 0;
  }

  function getCartCount() {
    var el = document.querySelector('cart-icon');
    if (el) return parseInt(el.getAttribute('count') || el.textContent, 10) || 0;
    var bubble = document.querySelector('[data-cart-item-count]');
    if (bubble) return parseInt(bubble.textContent, 10) || 0;
    return 0;
  }

  // ── Re-init on cart content updates ───────────────────────────
  function reInit() {
    initCountdown();
    initFreeGift();
    evaluateCartRules();
    updateStickyBadge();
  }

  function observeCartDrawer() {
    var inner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
    if (!inner) return;
    var debounceTimer;
    new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(reInit, 120);
    }).observe(inner, { childList: true, subtree: true });
  }

  function observeDialogOpen() {
    var dialog = document.querySelector('.cart-drawer__dialog');
    if (!dialog) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'open' && dialog.hasAttribute('open')) {
          animateFills();
        }
      });
    }).observe(dialog, { attributes: true });
  }

  // ── Bootstrap ──────────────────────────────────────────────────
  function init() {
    animateFills();
    initCountdown();
    initFreeGift();
    evaluateCartRules();
    initStickyCartButton();
    observeCartDrawer();
    observeDialogOpen();

    document.addEventListener('CartAddEvent', function () {
      setTimeout(updateStickyBadge, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
